module.exports = __webpack_public_path__ + "img/Wp_2046.24a33c9e.png";